<template>
  <div class="d-flex flex-column" style="height: 100%">
    <div rounded
      class="d-flex flex-column rounded align-center grey--text text-darken-1 py-2"
      style="background-color: #E1EDE1; border: 1px solid #CEE7CF;"
    >
      <div >Missed Rewards</div>
      <div class="black--text font-weight-bold" style="font-size: 22px;">
        {{ $formatters.formatCurrency(me.missed_rewards_cents) }}
      </div>
      <div style="font-size: 12px">Don't miss out on future rewards</div>
    </div>

    <Section class="px-4">
      <div class="d-flex flex-column">
        <div class="font-weight-bold black--text">Start Earning Rewards Today!</div>
        <div class="mt-3">
          One quick step, and you're ready to get paid for every referral.
          We keep your info safe, secure, and only use it for payouts.
        </div>

        <div class="d-flex flex-wrap mt-4" style="column-gap: 12px">
          <CatalogItem small v-for="item in catalog.items" :key="item.utid" :item="item"/>
        </div>

        <div class="d-flex justify-center mt-4">
          <v-btn color="primary" :to="{ name: 'w9/form' }">Get Paid</v-btn>
        </div>
      </div>  
    </Section>
  </div>
</template>

<script>
import CatalogItem from '../../../Redeem/CatalogItem'
import { Section } from '@/components/pages'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RewardsMissed',

  components: { CatalogItem, Section },

  data: () => ({
    page: 1,
    pageSize: 0,
    lastPage: -1,
    lastOffset: -1,

    resizeObserver: null,

    uuid: Math.floor(Math.random() * 1_000_000),
  }),

  computed: {
    ...mapGetters('auth', ['me']),
    ...mapGetters('rewards', ['catalog']),
  },

  methods: {
    ...mapActions('rewards', ['loadCatalog']),
  },

  created() {
    this.loadCatalog()
  }
}


</script>
